import React from 'react';
import { UnStyledLink } from '@/components/common/link';
import { FOOTER_PAYMENT_ITEMS } from '@/components/layout/footer/footer-payments/footer-payment-items';
import { useTenant } from '@/providers/TenantProvider';

const FooterPayments: React.FC = () => {
  const {
    tenantConfig: { settings },
  } = useTenant();

  const filteredFooterPaymentItems = FOOTER_PAYMENT_ITEMS.filter(
    ({ id }) => !(!settings.enableVatanCoinPromotion && id === 'VATAN')
  );

  return (
    <div className="grid w-full grid-flow-col grid-rows-2 items-center justify-center gap-4 py-5 sm:flex sm:gap-0 sm:space-x-10 rtl:space-x-reverse">
      {filteredFooterPaymentItems.map(({ id, href, Icon }) => (
        <UnStyledLink
          key={id}
          title={id}
          href={href}
          className="group flex h-10 w-10 items-center justify-center rounded-full p-[1px] transition-all duration-300 ease-in-out hover:scale-110 hover:shadow-lg hover:vt-atoms-btn-primary-bg"
        >
          <Icon className="size-8 transform transition-transform duration-500 ease-in-out group-hover:rotate-[360deg]" />
        </UnStyledLink>
      ))}
    </div>
  );
};

export default FooterPayments;
